import axios from 'axios';

/**
 * Calls the /api/user/login endpoint with username and password using axios.
 * @param username - The user's username
 * @param password - The user's password
 * @returns The response JSON from the API
 */
export async function loginUser(username: string, password: string) {
    const response = await axios.post('/api/user/login', { username, password });
    return response.data;
}

export async function logoutUser() {
    const response = await axios.post('/api/user/logout');
    return response.data;
}
